import { AddPremiumStores } from '@/features/store-management/premium-stores/AddPremiumStore';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/premium-stores/add-premium-store/')({
  component: RouteComponent,
  loader: () => {},
});

function RouteComponent() {
  return <AddPremiumStores />;
}
